import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import DatepickerContent from 'core/gd-components/datetime/datepicker/datepicker-content';

import Moment from 'moment';
import DatetimeUtils from "core/gd/utils/datetime-utils";

module.exports = class ModalActionsDeadline extends React.Component {
    static propTypes = {
        params: PropTypes.shape({
            onSubmit: PropTypes.func.isRequired,
            item    : PropTypes.object,
            btnUnset: PropTypes.bool
        })
    }

    constructor(props) {
        super(props);

        const initFormData = {
            deadline: _.get(props.params.item, 'deadline', null)
        }

        const formStructure = {
            fields: {
                deadline: {
                    type: 'select',
                    isRequired: false
                }
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.params.onSubmit(DatetimeUtils.dateTruncTime(result.deadline));
    }

    onSelect = (moment) => {
        this.form.setValue('deadline', moment);
        this.form.onSubmitClick();
    }

    render() {
        const value = this.form.getValue('deadline');

        return (
            <div className="gd-form-modal">
                <div className="row">
                    <DatepickerContent value                = {value}
                                       onSelect             = {this.onSelect}
                                       minDate              = {Moment()}
                                       btnNoValue           = {!!value || this.props.params.btnUnset}
                                       btnNoValueLabel      = "No deadline"
                                       customButtonsNoBg    = {true}/>
                </div>
            </div>
        );
    }
};